export const foldLyrics = [
  { text: "Won't fold", start:0 , end:2.8  },
  { text: "Dog barks", start: 3.0, end: 3.5 },
  { text: "Dog barks", start: 3.5, end: 4 },
  { text: "Won't fold", start: 4, end: 6.5 },
  { text: "I always said", start: 7, end: 8 },
  { text: "It was never about the money", start: 8, end: 9.9 },
  { text: "It was always about the terms", start: 9.9, end: 11.3 },
  { text: "Dog barks", start: 11.5, end: 12.5 },
  { text: "Dog barks", start: 12.5, end: 13.5 },
  { text: "Dog barks", start: 13.5, end: 15 },
  { text: "Won't fold", start: 15.82, end: 17.8 },
  { text: "Dog barks", start: 17.8, end: 18 },
  { text: "Won't fold", start: 18, end: 20 },
  { text: "Dog barks", start: 20, end: 21.5 },
  { text: "Dog barks", start: 21.5, end: 22 },
  { text: "Won't fold", start: 22, end: 25 },
  { text: "Dog barks", start: 26, end: 27 },
  { text: "Dog barks", start: 27, end: 28 },
  { text: "I won't fold", start: 29, end: 30 },
  { text: "I'm in my bag", start: 30, end: 31.7 },
  { text: "I just popped the tag", start: 31.7, end: 33.4 },
  { text: "Labels keep feeding me bullshit", start: 33.4, end: 35.7 },
  { text: "I don't give a damn", start: 35.7, end: 37.3 },
  { text: "They wanna run up a bag could give a fuck who I am", start: 37.3, end: 40.7 },
  { text: "But I won't fold no", start: 40.7, end: 42.4 },
  { text: "I won't fold", start: 42.4, end: 45.4 },
  { text: "You say you a fan", start: 45.4, end: 46.5 },
  { text: "You fuck with the brand", start: 46.5, end: 48.3 },
  { text: "I'm up to speed on your bullshit I don't give a damn", start: 48.3, end: 51.7 },
  { text: "I'll sacrifice a few bags just to own who I am", start: 51.7, end: 55.6 },
  { text: "Mmm", start: 55.06, end: 58 },
  { text: "See the funny thing about greed is it doesn't feed you", start: 58, end: 62.2 },
  { text: "I won't fold", start: 69, end: 71.8 },
  { text: "The more of these meetings I sit in", start: 72, end: 74.6 },
  { text: "I'm put in boxes to fit in", start: 74.6, end: 76.4 },
  { text: "You bring the tables I flip em", start: 76.4, end: 77.5 },
  { text: "more like bus", start: 77.5, end: 79 },
  { text: "once you realize you can't buy my trust", start: 79, end: 80.7 },
  { text: "Lump sum lump sum", start: 80.7, end: 81 },
  { text: "Oh I get for six albums I'll get ten benjies", start: 81, end: 84.8 },
  { text: "And if I'm lucky", start: 84.8, end: 86.6 },
  { text: "if I'm lucky", start: 86.6, end: 87 },
  { text: "if I'm lucky", start: 87, end: 87.5 },
  { text: "I'll get my masters in a suitcase", start: 87.5, end: 89 },
  { text: "On the front seat of a new car", start: 89, end: 91.3 },
  { text: "Hopefully it come wit a bitch and a chain", start: 91.3, end: 93 },
  { text: "When the money dries up least I'll be on the charts", start: 93, end: 95 },
  { text: "Till I realized", start: 95, end: 95.9 },
  { text: "Yo hands in my pockets", start: 95.9, end: 97 },
  { text: "I'm on a shelf while you turnin a profit", start: 97, end: 99.1 },
  { text: "Funding who's next", start: 99.1, end: 100 },
  { text: "Next on the docket", start: 100, end: 101 },
  { text: "While I'm on TikTok workin this record", start: 101, end: 102.5 },
  { text: "Stead of my optionsssss", start: 102.5, end: 105.8 },
  { text: "Job well done", start: 105.8, end: 110.5 },
  { text: "You played yourself", start: 110.5, end: 113.6 },
  { text: "Cause imma keep it g real", start: 113.6, end: 117.9 },
  { text: "I don't fuck with you cuz", start: 117.9, end: 119.4 },
  { text: "You disrespected me", start: 119.4, end: 120 },
  { text: "You disrespected my hood", start: 120, end: 120.8 },
  { text: "By telling me", start: 120.08, end: 122 },
  { text: "Take off my flag", start: 122, end: 123 },
  { text: "Asking how gangster I was", start: 123, end: 124 },
  { text: "You lucky that day", start: 124, end: 125 },
  { text: "I was actin' cool cuz", start: 125, end: 126.7 },
  { text: "I told you I aint got time for that", start: 126.7, end: 128.1 },
  { text: "Today I got time cuz", start: 128.1, end: 130 },
  { text: "Today I got time cuz", start: 130, end: 131.9 },
  { text: "Turn me up", start: 131.9, end: 133 },
  { text: "Real niggas don't fold", start: 134, end: 140.7 },
  { text: "Play your part", start: 140.7, end: 142.3 },
  { text: "Know your role", start: 142.3, end: 143.8 },
  { text: "Real niggas don't fold", start: 143.8, end: 147.5 },
  { text: "Play your part", start: 147.5, end: 149 },
  { text: "Know your role", start: 149, end: 150.5 },
  { text: "Real niggas don't fold", start: 150.5, end: 153.1 },
  { text: "Play your part", start: 153.1, end: 154.5 },
  { text: "Know your role", start: 154.5, end: 157 },
  { text: "Carry on", start: 162, end: 163 },
  { text: "I won't fold", start: 163, end: 165 },
  { text: "I'm in my bag", start: 165.5, end: 166 },
  { text: "I just popped the tag", start: 166, end: 167 },
  { text: "Labels keep feeding me bullshit", start: 167, end: 170.5 },
  { text: "I don't give a damn", start: 170.5, end: 171.5 },
  { text: "They wanna run up a bag could give a fuck who I am", start: 171.5, end: 174.5},
  { text: "Don't give a damn", start: 174.5, end: 175 },
  { text: "But I won't fold no", start: 175, end: 176 },
  { text: "I won't fold", start: 176, end: 177 },
  { text: "You say you a fan", start: 178, end: 181 },
  { text: "You fuck with the brand", start: 181, end: 182.5 },
  { text: "I'm up to speed on your bullshit I don't give a damn", start: 182.5, end: 186.1 },
  { text: "I'll sacrifice a few bags if I can own who I am", start: 186.1, end: 189.9 },
  { text: "I won't fold", start: 189.9, end: 192 },
  { text: "Dog barks", start: 196.5, end: 197 },
  { text: "Dog barks", start: 197, end: 199 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
